'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _times = require('HubStyleTokens/times');

var _TwoWayTransition = require('../../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _ModalTransitionContext = require('../../context/ModalTransitionContext');

var _overlayTransitionMixin = require('./overlayTransitionMixin');

var _UIDialog = require('../UIDialog');

var _UIDialog2 = _interopRequireDefault(_UIDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var totalTransitionTime = parseInt(_times.DEFAULT_MODAL_TRANSITION_TIMING, 10);
var overlayTransitionTime = parseInt(_times.MODAL_BACKGROUND_TRANSITION_TIMING, 10);
var dialogTransitionTime = totalTransitionTime - overlayTransitionTime;

var overlayTransition = (0, _overlayTransitionMixin.getOverlayTransition)(dialogTransitionTime);

var ModalTransitionWrapper = (0, _styledComponents2.default)(_TwoWayTransition2.default.PlainWrapper).withConfig({
  displayName: 'ModalTransition__ModalTransitionWrapper'
})(['', '{transition-property:', ';transition-delay:', 'ms;transition-duration:', 'ms;opacity:', ';transform:', ';}', ';'], _UIDialog2.default.Selector, function (_ref) {
  var transitionActive = _ref.transitionActive;
  return transitionActive ? 'opacity, transform' : 'none';
}, overlayTransitionTime, dialogTransitionTime, function (_ref2) {
  var open = _ref2.open;
  return open ? '1' : '0';
}, function (_ref3) {
  var open = _ref3.open;
  return 'scale(' + (open ? '1' : '0.9') + ')';
}, overlayTransition);

var ModalTransition = function ModalTransition(props) {
  return _react2.default.createElement(_TwoWayTransition2.default, _extends({}, props, {
    ContextProvider: _ModalTransitionContext.ModalTransitionContextProvider,
    duration: totalTransitionTime,
    transitionOnMount: true,
    Wrapper: ModalTransitionWrapper
  }));
};

ModalTransition.displayName = 'ModalTransition';

exports.default = ModalTransition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/internal/ModalTransition.js
// module id = 551
// module chunks = 177